import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const BACKEND_URL = "https://reflex-backend.alfaoir1.workers.dev";

export default function BusinessDirectory() {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [areaFilter, setAreaFilter] = useState("");

  useEffect(() => {
    fetch(`${BACKEND_URL}/businesses`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setBusinesses(data.businesses);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const areas = [...new Set(businesses.map(b => b.serviceArea).filter(Boolean))];

  const filtered = businesses.filter(b => {
    const q = search.toLowerCase();
    const matchSearch =
      !q ||
      (b.businessName || "").toLowerCase().includes(q) ||
      (b.name || "").toLowerCase().includes(q) ||
      (b.services || "").toLowerCase().includes(q) ||
      (b.about || "").toLowerCase().includes(q);
    const matchArea = !areaFilter || b.serviceArea === areaFilter;
    return matchSearch && matchArea;
  });

  return (
    <div style={{ background: "#f7f7f5", minHeight: "100vh", paddingTop: "80px", fontFamily: "'DM Sans', -apple-system, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Serif+Display&display=swap');
        .biz-card { transition: transform 0.2s ease, box-shadow 0.2s ease; }
        .biz-card:hover { transform: translateY(-4px); box-shadow: 0 12px 40px rgba(0,0,0,0.12) !important; }
        .view-btn:hover { background: #1a1a2e !important; color: #fff !important; }
        .search-input:focus { outline: none; border-color: #7b19bc !important; box-shadow: 0 0 0 3px rgba(123,25,188,0.1); }
        .tag-pill { display: inline-block; background: #f0e8ff; color: #6b13a8; padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 500; margin: 2px; }
        .filter-select:focus { outline: none; border-color: #7b19bc !important; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        .card-animate { animation: fadeUp 0.4s ease forwards; opacity: 0; }
      `}</style>

      {/* HEADER */}
      <div style={{ background: "#1a1a2e", padding: "56px 24px 48px" }}>
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <p style={{ color: "#a78bda", fontSize: "13px", fontWeight: 600, letterSpacing: "2px", textTransform: "uppercase", marginBottom: "12px" }}>
            Find a Professional
          </p>
          <h1 style={{ color: "#fff", fontSize: "clamp(28px, 4vw, 44px)", fontFamily: "'DM Serif Display', serif", fontWeight: 400, margin: "0 0 8px", lineHeight: 1.2 }}>
            Browse Business Directory
          </h1>
          <p style={{ color: "#9ca3b8", fontSize: "16px", margin: "0 0 36px" }}>
            Connect with verified professionals and service providers
          </p>

          {/* SEARCH + FILTER */}
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            <div style={{ position: "relative", flex: "1", minWidth: "260px" }}>
              <svg style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", color: "#9ca3b8" }}
                width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
              </svg>
              <input
                className="search-input"
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search by name, business or service..."
                style={{ width: "100%", padding: "13px 14px 13px 42px", borderRadius: "10px", border: "1.5px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.08)", color: "#fff", fontSize: "14px", boxSizing: "border-box", fontFamily: "inherit" }}
              />
            </div>
            {areas.length > 0 && (
              <select
                className="filter-select"
                value={areaFilter}
                onChange={e => setAreaFilter(e.target.value)}
                style={{ padding: "13px 16px", borderRadius: "10px", border: "1.5px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.08)", color: areaFilter ? "#fff" : "#9ca3b8", fontSize: "14px", cursor: "pointer", fontFamily: "inherit", minWidth: "180px" }}
              >
                <option value="" style={{ background: "#1a1a2e" }}>All Service Areas</option>
                {areas.map(a => (
                  <option key={a} value={a} style={{ background: "#1a1a2e" }}>{a}</option>
                ))}
              </select>
            )}
          </div>
        </div>
      </div>

      {/* RESULTS COUNT */}
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "24px 24px 0" }}>
        {!loading && (
          <p style={{ color: "#888", fontSize: "14px", margin: 0 }}>
            {filtered.length === 0 ? "No businesses found" : `${filtered.length} business${filtered.length !== 1 ? "es" : ""} found`}
          </p>
        )}
      </div>

      {/* GRID */}
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "20px 24px 60px" }}>
        {loading ? (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "20px" }}>
            {[...Array(6)].map((_, i) => (
              <div key={i} style={{ background: "#fff", borderRadius: "16px", padding: "24px", border: "1px solid #ebebeb" }}>
                <div style={{ display: "flex", gap: "14px", alignItems: "center", marginBottom: "16px" }}>
                  <div style={{ width: "60px", height: "60px", borderRadius: "50%", background: "#f0f0f0" }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ height: "14px", background: "#f0f0f0", borderRadius: "6px", marginBottom: "8px", width: "70%" }} />
                    <div style={{ height: "12px", background: "#f0f0f0", borderRadius: "6px", width: "50%" }} />
                  </div>
                </div>
                <div style={{ height: "12px", background: "#f0f0f0", borderRadius: "6px", marginBottom: "8px" }} />
                <div style={{ height: "12px", background: "#f0f0f0", borderRadius: "6px", width: "80%" }} />
              </div>
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "80px 20px" }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5" style={{ marginBottom: "16px" }}>
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <p style={{ color: "#999", fontSize: "16px", margin: 0 }}>No businesses match your search.</p>
            <button onClick={() => { setSearch(""); setAreaFilter(""); }}
              style={{ marginTop: "16px", padding: "10px 24px", background: "#7b19bc", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "14px", fontWeight: 600 }}>
              Clear Filters
            </button>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(310px, 1fr))", gap: "20px" }}>
            {filtered.map((biz, i) => (
              <BusinessCard key={biz.email} biz={biz} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function BusinessCard({ biz, index }) {
  const services = biz.services
    ? biz.services.split("\n").map(s => s.trim()).filter(Boolean).slice(0, 3)
    : [];

  return (
    <div
      className="biz-card card-animate"
      style={{
        background: "#fff",
        borderRadius: "16px",
        border: "1px solid #ebebeb",
        padding: "24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        display: "flex",
        flexDirection: "column",
        animationDelay: `${index * 60}ms`,
      }}
    >
      {/* TOP ROW */}
      <div style={{ display: "flex", gap: "14px", alignItems: "flex-start", marginBottom: "14px" }}>
        <div style={{ flexShrink: 0 }}>
          {biz.profilePicture ? (
            <img src={biz.profilePicture} alt={biz.name}
              style={{ width: "62px", height: "62px", borderRadius: "50%", objectFit: "cover", border: "2px solid #f0e8ff" }} />
          ) : (
            <div style={{ width: "62px", height: "62px", borderRadius: "50%", background: "linear-gradient(135deg, #f0e8ff, #e0d0ff)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", fontWeight: 700, color: "#7b19bc", border: "2px solid #f0e8ff" }}>
              {(biz.businessName || biz.name || "?").charAt(0).toUpperCase()}
            </div>
          )}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{ margin: "0 0 2px", fontSize: "16px", fontWeight: 700, color: "#1a1a2e", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {biz.businessName || biz.name || "Unnamed Business"}
          </h3>
          <p style={{ margin: "0 0 4px", fontSize: "13px", color: "#888", fontWeight: 500 }}>
            {biz.name || ""}
          </p>
          {biz.serviceArea && (
            <span style={{ display: "inline-flex", alignItems: "center", gap: "3px", fontSize: "12px", color: "#aaa" }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
              </svg>
              {biz.serviceArea}
            </span>
          )}
        </div>
      </div>

      {/* ABOUT */}
      {biz.about && (
        <p style={{ margin: "0 0 14px", fontSize: "13px", color: "#666", lineHeight: 1.6, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
          {biz.about}
        </p>
      )}

      {/* SERVICES TAGS */}
      {services.length > 0 && (
        <div style={{ marginBottom: "16px", display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {services.map((s, i) => (
            <span key={i} className="tag-pill">{s}</span>
          ))}
          {biz.services.split("\n").filter(s => s.trim()).length > 3 && (
            <span className="tag-pill" style={{ background: "#f5f5f5", color: "#999" }}>
              +{biz.services.split("\n").filter(s => s.trim()).length - 3} more
            </span>
          )}
        </div>
      )}

      {/* STATS */}
      {(biz.truckCount || biz.teamSize) && (
        <div style={{ display: "flex", gap: "16px", marginBottom: "16px", paddingBottom: "16px", borderBottom: "1px solid #f5f5f5" }}>
          {biz.truckCount && (
            <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", color: "#777" }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="1" y="3" width="15" height="13"/><polygon points="16,8 20,8 23,11 23,16 16,16 16,8"/>
                <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
              </svg>
              {biz.truckCount} {biz.truckCount === "1" ? "Truck" : "Trucks"}
            </div>
          )}
          {biz.teamSize && (
            <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "12px", color: "#777" }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>
              </svg>
              Team of {biz.teamSize}
            </div>
          )}
        </div>
      )}

      {/* FOOTER */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "auto" }}>
        <div style={{ display: "flex", gap: "8px" }}>
          {biz.website && (
            <a href={biz.website} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
              style={{ color: "#bbb", display: "flex", alignItems: "center" }} title="Website">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/>
              </svg>
            </a>
          )}
          {biz.facebook && (
            <a href={biz.facebook} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
              style={{ color: "#bbb", display: "flex", alignItems: "center" }} title="Facebook">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
              </svg>
            </a>
          )}
          {biz.instagram && (
            <a href={biz.instagram} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
              style={{ color: "#bbb", display: "flex", alignItems: "center" }} title="Instagram">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
              </svg>
            </a>
          )}
        </div>

        <Link
          to={`/business/${encodeURIComponent(biz.name)}`}
          className="view-btn"
          style={{ padding: "8px 18px", background: "#f0e8ff", color: "#7b19bc", border: "none", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: 600, textDecoration: "none", transition: "all 0.2s" }}
        >
          View Profile →
        </Link>
      </div>
    </div>
  );
}